// Era metadata. Eras 1-6 are calendar-driven; era 7 (Space) is research/milestone-gated
// and is never returned by eraForYear().
import { dateToDay } from '../core/time.js';

export const ERAS = [
  {
    id: 'pioneer', name: 'Pioneer', num: 1, startYear: 1859, endYear: 1900,
    start: [1859, 1, 1], calendar: true, roman: 'I',
    blurb: 'Rock oil from Pennsylvania creek beds. Spring poles, cable tools, steam, and barrels worth more than the oil in them.',
  },
  {
    id: 'gusher', name: 'Gusher & Rotary', num: 2, startYear: 1901, endYear: 1945,
    start: [1901, 1, 1], calendar: true, roman: 'II',
    blurb: 'Spindletop roars. Rotary rigs, drilling mud, cone bits, blowout preventers and the first seismic crews.',
  },
  {
    id: 'postwar', name: 'Postwar & Middle East', num: 3, startYear: 1946, endYear: 1972,
    start: [1946, 1, 1], calendar: true, roman: 'III',
    blurb: 'Desert concessions, fifty-fifty deals, diesel-electric rigs and the first platforms out of sight of land.',
  },
  {
    id: 'offshore', name: 'Offshore & Crisis', num: 4, startYear: 1973, endYear: 1999,
    start: [1973, 10, 16], calendar: true, roman: 'IV',
    blurb: 'Embargoes and price shocks. North Sea storms, drillships, PDC bits, 3D seismic and horizontal wells.',
  },
  {
    id: 'shale', name: 'Shale & Deepwater', num: 5, startYear: 2000, endYear: 2029,
    start: [2000, 1, 1], calendar: true, roman: 'V',
    blurb: 'Multi-stage fracs, pad drilling, ultra-deepwater and pre-salt. The decline treadmill never stops.',
  },
  {
    id: 'future', name: 'Near Future', num: 6, startYear: 2030, endYear: 2079,
    start: [2030, 1, 1], calendar: true, roman: 'VI',
    blurb: 'Carbon taxes, Arctic ice, autonomous subsea rigs, AI drillers and laser bits. Propellant becomes the new crude.',
  },
  {
    id: 'space', name: 'Space', num: 7, startYear: 2060, endYear: null,
    start: [2060, 1, 1], calendar: false, roman: 'VII',
    unlock: { research: 'off_world_drilling', netWorth2025: 5e9 },
    blurb: 'Ice on the Moon, clathrates on Mars, hydrocarbon seas on Titan. Same verbs, lower gravity.',
  },
];

export const ERA_BY_ID = Object.fromEntries(ERAS.map((e) => [e.id, e]));

const CAL = ERAS.filter((e) => e.calendar);
for (const e of CAL) e.startDay = dateToDay(...e.start);

// Calendar era for a given day (respects mid-year starts, e.g. 16 Oct 1973).
export function eraForDay(day) {
  let cur = CAL[0];
  for (const e of CAL) if (day >= e.startDay) cur = e;
  return cur;
}

// Calendar era for a year (by 1 Jan of that year, except a year containing a mid-year start
// is assigned by startYear/endYear ranges). Never returns the space era.
export function eraForYear(year) {
  const y = Math.floor(year);
  for (const e of CAL) if (y >= e.startYear && y <= e.endYear) return e;
  return y < CAL[0].startYear ? CAL[0] : CAL[CAL.length - 1];
}

